import React from 'react';
import { FormikTextInput } from 'src/common/form/formik/text-input';

const ShareContactEmailInput = (props: { value: string, onChange: (e:React.ChangeEvent<string>) => void, disabled: boolean, mergeField?: string | undefined | null }) => {
  return (
    <div className='flex flex-col space-y-2 pb-6'>
      <FormikTextInput
        maxLength={100}
        hideCharacterCount
        id='journey-share-alias-form-contact-email'
        name='hubspot_contact_email'
        label='Email Address'
        placeholder='Contact Email'
        type='email'
        autoComplete='off'
        autoCapitalize='off'
        autoCorrect='off'
        spellCheck='false'
        onChange={props.onChange}
        mergeField={props.mergeField}
        value={props.value}
        disabled={props.disabled}
      />
    </div>
  );
};

export default ShareContactEmailInput;
